import React from "react";

const MenuFold: React.FC<React.SVGProps<SVGSVGElement>> = ({
  height = 24,
  width = 24,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_40000332_5222)">
        <path
          d="M9.16667 5.83325L5 9.99992L9.16667 14.1666"
          stroke="#707A8F"
          strokeWidth="1.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.1667 5.83325L10 9.99992L14.1667 14.1666"
          stroke="#707A8F"
          strokeWidth="1.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_40000332_5222">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default MenuFold;
